<template>
  <section id="nft" class="nft">

    <section class="nft-top panel" data-color="green">
      <div class="container">
        <div class="nft-top-wrapper">
          <h4><span><img src="../assets/images/services/nfts/hqO.gif" alt="" /></span> The Metaverse’s Premium <span><img src="../assets/images/services/nfts/2IND.gif" alt="" /></span> NFT Illustration & Animation <span><img src="../assets/images/services/nfts/J3XN.gif" alt="" /></span> Agency</h4>
        </div>
      </div>
    </section>

    <section class="nft-about panel" data-color="red">
      <div class="container">
        <div class="nft-about-wrapper">
          <h5 class="lightSpeedIn" v-wow="{ 'animation-name': 'lightSpeedIn'}">TIBNFT is a creative team focused on NFT art creation and animation design.</h5>
          <h5 class="lightSpeedIn" v-wow="{ 'animation-name': 'lightSpeedIn'}">We are a digital space for collaboration between creatives and technology to help others tell their story.</h5>
          <a href="#contact" class="fadeInUp move-down" v-wow="{ 'animation-name': 'fadeInUp'}" data-cursor-hover data-cursor-mix-blend-mode="difference">Enter the Metaverse</a>
        </div>
      </div>
    </section>

    <section class="nft-what panel" data-color="green">
      <div class="container">
        <div class="nft-what-wrapper">
          <div class="nft-what-wrapper-left">
            <h4 class="lightSpeedIn" v-wow="{ 'animation-name': 'lightSpeedIn'}">What is <br />an NFT?</h4>
            <p class="lightSpeedIn" v-wow="{ 'animation-name': 'fadeInUp', 'animation-delay': '.5s'}">An NFT is a blockchain “non-fungible token”. They’re unique and cannot be copied, changed, or disputed. An NFT can be any form of digital art, and can be sold as a limited edition or part of a collection. Cryptopunks and BAYC are arguably in the most popular genre, being avatar style projects. The market is quickly evolving so it’s imperative to produce quality pieces of NFT art.</p>
          </div>
          <div class="nft-what-wrapper-right lightSpeedIn" v-wow="{ 'animation-name': 'lightSpeedIn'}">
            <img src="../assets/images/services/nfts/7ZDI.gif" alt="" />
          </div>
        </div>
      </div>
    </section>

    <section class="nft-what panel" data-color="gray">
      <div class="nft-what-bottom">
        <div class="container">
          <h4 class="lightSpeedIn" v-wow="{ 'animation-name': 'lightSpeedIn'}">Have an idea for an NFT project, but not an artist yourself?</h4>
          <!-- p v-wow="{ 'animation-name': 'fadeInUp', 'animation-delay': '.5s'}">We have a network of illustrators and artists to bring your ideas to life. </p-->
          <a href="#contact" class="fadeInUp move-down" v-wow="{ 'animation-name': 'fadeInUp', 'animation-delay': '.5s'}" data-cursor-hover data-cursor-mix-blend-mode="difference">Share Your Idea</a>
        </div>
      </div>
    </section>

    <section class="nft-benefit panel" data-color="red">
      <div class="container">
        <h4 class="lightSpeedIn" v-wow="{ 'animation-name': 'lightSpeedIn'}">Benefits with using a creative agency such as TIBNFT</h4>
        <div class="nft-benefit-wrapper">
          <div class="nft-benefit-wrapper-left lightSpeedIn" v-wow="{ 'animation-name': 'lightSpeedIn'}">
            <img src="../assets/images/services/nfts/3Pey.gif" alt="" />
          </div>
          <div class="nft-benefit-wrapper-right">
            <h5 class="lightSpeedIn" v-wow="{ 'animation-name': 'lightSpeedIn'}">Art & Animation</h5>
            <p class="lightSpeedIn" v-wow="{ 'animation-name': 'fadeInUp', 'animation-delay': '.5s'}">An award winning and expert team of illustrators, artists and animators to take an idea to digital art.</p>
          </div>
        </div>
        <div class="nft-benefit-wrapper nft-benefit-wrapper-reverse">
          <div class="nft-benefit-wrapper-left">
            <img src="../assets/images/services/nfts/Rkwm.gif" alt="" />
          </div>
          <div class="nft-benefit-wrapper-right lightSpeedIn" v-wow="{ 'animation-name': 'lightSpeedIn'}">
            <h5 class="lightSpeedIn" v-wow="{ 'animation-name': 'lightSpeedIn'}">Experience</h5>
            <p class="lightSpeedIn" v-wow="{ 'animation-name': 'fadeInUp', 'animation-delay': '.5s'}">Years of experience with storytelling and digital experiences for startups to large businesses globally.</p>
          </div>
        </div>
        <div class="nft-benefit-wrapper">
          <div class="nft-benefit-wrapper-left lightSpeedIn" v-wow="{ 'animation-name': 'lightSpeedIn'}">
            <img src="../assets/images/services/nfts/7tCU.gif" alt="" />
          </div>
          <div class="nft-benefit-wrapper-right">
            <h5 class="lightSpeedIn" v-wow="{ 'animation-name': 'lightSpeedIn'}">Direction & Strategy</h5>
            <p class="lightSpeedIn" v-wow="{ 'animation-name': 'fadeInUp', 'animation-delay': '.5s'}">TIBNFT can help with the creative process alongside you and the artists, crafting both art direction and strategy.</p>
          </div>
        </div>
      </div>
    </section>

    <section class="nft-brought-life panel" data-color="red">
      <div class="container">
        <div class="nft-brought-life-wrapper">
          <h4 class="lightSpeedIn" v-wow="{ 'animation-name': 'lightSpeedIn'}">Your NFT Art, <br />brought to life</h4>
          <p class="lightSpeedIn" v-wow="{ 'animation-name': 'fadeInUp', 'animation-delay': '.5s'}">Already have NFTs created, or you’re an artist and need an animator to bring your creations to life? Let our animators work their magic.</p>
          <a href="#contact" class="lightSpeedIn move-down" v-wow="{ 'animation-name': 'fadeInUp', 'animation-delay': '.5s'}">Get Started</a>
        </div>
      </div>
    </section>

    <section class="nft-arts panel" data-color="red">
      <div class="container">
        <div class="nft-arts-wrapper">
          <h4 class="lightSpeedIn" v-wow="{ 'animation-name': 'lightSpeedIn'}">Art & Creations</h4>
          <p class="lightSpeedIn" v-wow="{ 'animation-name': 'fadeInUp', 'animation-delay': '.5s'}">We love getting weird and creative. Here's some fun work.</p>
          <ul class="lightSpeedIn" v-wow="{ 'animation-name': 'fadeInUp', 'animation-delay': '1s'}">
            <li class="lightSpeedIn" v-wow="{ 'animation-name': 'lightSpeedIn'}">
              <parallax-container>
                <parallax-element :parallaxStrength="25" :type="'depth'">
                  <img src="../assets/images/services/nfts/art1.png" alt="" />
                </parallax-element>
              </parallax-container>
            </li>
            <li class="lightSpeedIn" v-wow="{ 'animation-name': 'lightSpeedIn'}">
              <parallax-container>
                <parallax-element :parallaxStrength="25" :type="'depth'">
                  <img src="../assets/images/services/nfts/art2.png" alt="" />
                </parallax-element>
              </parallax-container>
            </li>
            <li class="lightSpeedIn" v-wow="{ 'animation-name': 'lightSpeedIn'}">
              <parallax-container>
                <parallax-element :parallaxStrength="25" :type="'depth'">
                  <img src="../assets/images/services/nfts/art3.png" alt="" />
                  </parallax-element>
              </parallax-container>
            </li>
            <li class="lightSpeedIn" v-wow="{ 'animation-name': 'lightSpeedIn'}">
              <parallax-container>
                <parallax-element :parallaxStrength="25" :type="'depth'">
                  <img src="../assets/images/services/nfts/art4.png" alt="" />
                  </parallax-element>
              </parallax-container>
            </li>
            <li class="lightSpeedIn" v-wow="{ 'animation-name': 'lightSpeedIn'}">
              <parallax-container>
                <parallax-element :parallaxStrength="25" :type="'depth'">
                <img src="../assets/images/services/nfts/art5.png" alt="" />
                </parallax-element>
              </parallax-container>
            </li>
            <li class="lightSpeedIn" v-wow="{ 'animation-name': 'lightSpeedIn'}">
              <parallax-container>
                <parallax-element :parallaxStrength="25" :type="'depth'">
                <img src="../assets/images/services/nfts/art6.png" alt="" />
                </parallax-element>
              </parallax-container>
            </li>
            <li class="lightSpeedIn" v-wow="{ 'animation-name': 'lightSpeedIn'}">
              <parallax-container>
                <parallax-element :parallaxStrength="25" :type="'depth'">
                <img src="../assets/images/services/nfts/art7.png" alt="" />
                </parallax-element>
              </parallax-container>
            </li>
            <li class="lightSpeedIn" v-wow="{ 'animation-name': 'lightSpeedIn'}">
              <parallax-container>
                <parallax-element :parallaxStrength="25" :type="'depth'">
                <img src="../assets/images/services/nfts/art8.png" alt="" />
                </parallax-element>
              </parallax-container>
            </li>
            <li class="lightSpeedIn" v-wow="{ 'animation-name': 'lightSpeedIn'}">
              <parallax-container>
                <parallax-element :parallaxStrength="25" :type="'depth'">
                <img src="../assets/images/services/nfts/art9.png" alt="" />
                </parallax-element>
              </parallax-container>
            </li>
          </ul>
        </div>
      </div>
    </section>

    <section class="nft-contact panel" data-color="green" id="contact">
      <div class="page-title">
        <div class="container">
          <div class="page-title-left">
            <div class="h3-tagline none" v-wow="{ 'animation-name': 'none'}"><span>Contact</span></div>
          </div>    
          <div class="page-title-right">
            <h4 class="lightSpeedIn" v-wow="{ 'animation-name': 'lightSpeedIn'}">Let us make you <br />something great!</h4>
            <p class="lightSpeedIn" v-wow="{ 'animation-name': 'fadeInUp', 'animation-delay': '.5s'}">Getting started is easy, just fill in the blanks below and we'll get back to you within <br />one working day wherever you are in the world.</p>
            <h4 class="success-msg" v-if="smsg == 1"><img src="../assets/images/done.png" alt="" /><span>We got it! <br />Will get back to you ASAP.</span></h4>
            <div class="" v-if="smsg == 0">
              <span class="error-msg" v-for="(e, index) in errors" :key="index">{{ e }}</span>
              <ul class="lightSpeedIn" v-wow="{ 'animation-name': 'fadeInUp', 'animation-delay': '1s'}">
                <li v-bind:class="{ active: nfts_name_isActive}">
                    <label>Name</label>
                    <input type="text" placeholder="" ref="nfts_name" v-model="form.nfts_name" @focus="nfts_name_isActive = true" @blur="field_blur()" />
                </li>
                <li v-bind:class="{ active: nfts_portfolio_isActive}">
                    <label>NFT Portfolio (optional)</label>
                    <input type="text" placeholder="" ref="nfts_portfolio" v-model="form.nfts_portfolio" @focus="nfts_portfolio_isActive = true" @blur="field_blur()" />
                </li>
                <li v-bind:class="{ active: nfts_email_isActive}">
                    <label>Email</label>
                    <input type="text" placeholder="" ref="nfts_email" v-model="form.nfts_email" @focus="nfts_email_isActive = true" @blur="field_blur()" />
                </li>
                <li v-bind:class="{ active: nfts_phone_isActive}">
                    <label>Phone (optional)</label>
                    <input type="text" placeholder="" ref="nfts_phone" v-model="form.nfts_phone" @focus="nfts_phone_isActive = true" @blur="field_blur()" />
                </li>
                <li class="full" v-bind:class="{ active: nfts_discord_name_isActive}">
                    <label>Discord Username (optional)</label>
                    <input type="text" placeholder="" ref="nfts_discord_name" v-model="form.nfts_discord_name" @focus="nfts_discord_name_isActive = true" @blur="field_blur()" />
                </li>
                <li class="full" v-bind:class="{ active: nfts_share_story_isActive}">
                    <label>Share Your Story</label>
                    <textarea ref="nfts_share_story" v-model="form.nfts_share_story" @focus="nfts_share_story_isActive = true" @blur="field_blur()"></textarea>
                </li>
                <li class="full">
                  <div v-if="sloading" v-cloak>
                    <i class="fa fa-circle-o-notch fa-spin fa-3x fa-fw"></i>
                    <span>Loading...</span>
                  </div>
                  <div v-else>
                    <button class="send-btn" @click.prevent="share" data-cursor-hover data-cursor-mix-blend-mode="difference">Share</button>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>

    <Footer />
    <cursor-fx color="#56320e" color-hover="#56320e" />
  </section>
</template>

<script>
import Footer from '@/components/Footer'
import $ from 'jquery'
import { TimelineMax, Linear, TweenMax } from 'gsap'
import ScrollMagic from 'scrollmagic'
import HoverEffect from 'hover-effect'
import { CursorFx } from '@luxdamore/vue-cursor-fx'
import '@luxdamore/vue-cursor-fx/dist/CursorFx.css'

export default {
  name: 'Nfts',
  data: () => ({
    sloading: false, 
    nfts_name_isActive: false,
    nfts_discord_name_isActive: false,
    nfts_email_isActive: false,
    nfts_phone_isActive: false,
    nfts_portfolio_isActive: false,
    nfts_share_story_isActive: false,
    errors: [],
    smsg: 0, 
    form: {
      nfts_name: null,
      nfts_discord_name: null,
      nfts_email: null,
      nfts_phone: null,
      nfts_portfolio: null,
      nfts_share_story: null
    }
  }),
  components: {
    Footer,
    CursorFx
  },
  methods: {
    checkForm: function (e) {
      if (!this.errors.length) {
        return true
      }
      e.preventDefault()
    },
    validNumber: function (n) {
      return !isNaN(parseFloat(n)) && isFinite(n)
    },
    validEmail: function (email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(email)
    },
    field_blur: function () {                        
      if (!this.form.nfts_name) {
        this.nfts_name_isActive = false
      }
      if (!this.form.nfts_discord_name) {
        this.nfts_discord_name_isActive = false
      }
      if (!this.form.nfts_email) {
        this.nfts_email_isActive = false
      }
      if (!this.form.nfts_phone) {
        this.nfts_phone_isActive = false
      }
      if (!this.form.nfts_portfolio) {
        this.nfts_portfolio_isActive = false
      }
      if (!this.form.nfts_share_story) {
        this.nfts_share_story_isActive = false
      }
    },
    share: function () {
      if (!this.form.nfts_name) {
        this.$refs.nfts_name.focus()
        this.errors = 'Please fill out your name'
        return false
      }
      if (!this.form.nfts_email) {
        this.$refs.nfts_email.focus()
        this.errors = 'Please fill out your email address'
        return false
      }
      if (!this.validEmail(this.form.nfts_email)) {
        this.$refs.nfts_email.focus()
        this.errors = 'Valid email required'
        return false
      }
      if (!this.form.nfts_share_story) {
        this.$refs.nfts_share_story.focus()
        this.errors = 'Please fill out your story'
        return false
      }
      this.sloading = true
      var $this = this
      $.ajax({
        type: 'POST',
        url: 'nftsmail.php',
        dataType: 'json',
        data: {
          'nfts_name': this.form.nfts_name,
          'nfts_discord_name': this.form.nfts_discord_name,
          'nfts_email': this.form.nfts_email,
          'nfts_phone': this.form.nfts_phone,
          'nfts_portfolio': this.form.nfts_portfolio,
          'nfts_share_story': this.form.nfts_share_story
        }
      }).always(function (response) {
        if (response.status) {
          $this.afterSubmit()          
          $this.smsg = 1
          $this.errors = []
        } else {
          $this.status = true     
          $this.errors = response.message
          $this.smsg = 0
          $this.afterSubmit(false)
        }
        $this.sloading = false
      })
      return false
    },
    afterSubmit: function ($goto = true) {
      this.sloading = false
      if ($goto) {
        this.form.nfts_name = ''
        this.form.nfts_discord_name = ''
        this.form.nfts_email = ''
        this.form.nfts_phone = ''
        this.form.nfts_portfolio = ''
        this.form.nfts_share_story = ''
        this.nfts_name_isActive = false
        this.nfts_discord_name_isActive = false
        this.nfts_email_isActive = false
        this.nfts_phone_isActive = false
        this.nfts_portfolio_isActive = false
        this.nfts_share_story_isActive = false
        this.step = 1
      }
    }
  },
  mounted () {
    $('.move-down').click(function () {
      var moveTo = $(this).attr('href')
      $('html, body').animate({ scrollTop: $(moveTo).offset().top }, 500)
    })
  },
  beforeCreate: function () {
    document.body.className = ''
  }
}
</script>

<style lang='scss'>
.cursor-fx{
  position:relative;
  z-index:99999;
  mix-blend-mode: difference;
  &__inner__inside{
    background-color:#56320e !important;
    border:0px !important;
  }
  &__inner__outside{
    background:#ceffc1 !important;
    border:0px !important;
  }
  &--hover{
    .cursor-fx__inner__inside{
      background-color:#56320e !important;
    }
    .cursor-fx__inner__outside{
      background:#ceffc1 !important;
    } 
  }
}
.nft{
  &-top{
    float:left;
    width:100%;
    height:100vh;
    display: flex;
    justify-content:center;
    align-items:center;
    text-align: left;
    .container{
      display: flex;
      justify-content:center;
      align-items:center;
    }
    &-wrapper{
      display: inline-block;
      padding-top:100px;
      width:100%;
      h4{
        font-size:110px;
        line-height:160px;
        letter-spacing:-2px;
        margin-bottom: 30px;
        span{
          display:inline-block;
          position:relative;
          width:180px;
          height:100px;
          img{
            position:absolute;
            left:50%;
            top:50%;
            transform:translate(-50%, -50%);
          }
        }
      }
      p{
        margin-bottom: 30px;
      }
    }
  }

  &-about{
    float:left;
    width:100%;
    padding:200px 0 0;
    display: flex;
    justify-content:center;
    align-items:center;
    .container{
      display: flex;
      justify-content:space-between;
      align-items:center;
    }
    &-wrapper{
      display: inline-block;
      width:100%;
      h5{
        font-size:72px;
        line-heigh:72px;
        color:#F4EEB4;
        margin-bottom: 100px;
      }
    }
  }

  &-what{
    float:left;
    width:100%;
    display: flex;
    justify-content:center;
    align-items:center;
    padding:200px 0;
    .container{
      display: flex;
      justify-content:space-between;
      align-items:center;
      flex-wrap:wrap;
    }
    &-wrapper{
      display: flex;
      justify-content:space-between;
      align-items: center;
      width: 100%;
      overflow:hidden;
      &-left{
        width:50%;
        padding:200px 100px 200px 0;
        h4{
          margin-bottom: 30px;
        }
        p{
          line-height: 1.5;
        }
      }
      &-right{
        width:50%;
        img{
          position:absolute;
          left:0;
          top:50%;
          transform:translate(0, -50%);
          width:50vw;
          max-width:50vw;
        }
      }
    }
    &-bottom{
      width: 100%;
      .container{
        display:block;
      }
      h4{
        font-size: 110px;
        color: #ffffff;
        line-height: 160px;
        letter-spacing: -2px;
        margin-bottom: 100px;
      }
      p{
        color: #f4eeb4;
        line-height: 1.5;
        margin-bottom: 80px;
      }
      a{
        display:inline-block;
      }
    }
  }

  &-benefit{
    float:left;
    width:100%;
    display: flex;
    justify-content:center;
    align-items:center;
    padding:200px 0;
    .container{
      display: flex;
      justify-content:space-between;
      align-items:center;
      flex-wrap:wrap;
      text-align:center;
      h4{
        font-size:72px;
        line-heigh:72px;
        color:#F4EEB4;
        margin-bottom: 100px;
      }
    }
    &-wrapper{
      display: flex;
      justify-content:space-between;
      align-items: center;
      width: 100%;
      height:500px;
      overflow:hidden;
      margin-bottom: 100px;
      overflow:hidden;
      text-align:left;
      &-reverse{
        text-align:right;
        flex-direction: row-reverse;
      }
      &:last-child{
        margin-bottom: 0;
      }
      &-left{
        width:50%;
        padding:25px;
        h5{
          color:#ffffff;
          margin-bottom: 30px;
        }
        p{
          color:#ffffff;
          line-height: 1.5;
        }
        img{
          width:750px;
        }
      }
      &-right{
        width:50%;
        padding:25px;
        h5{
          color:#ffffff;
          margin-bottom: 30px;
        }
        p{
          color:#ffffff;
          line-height: 1.5;
        }
        img{
          width:750px;
        }
      }
    }
  }

  &-brought-life{
    float:left;
    width:100%;
    padding:200px 0;
    display: flex;
    justify-content:center;
    align-items:center;
    background:url(../../src/assets/images/services/nfts/xK.gif);
    .container{
      display: flex;
      justify-content:space-between;
      align-items:center;
      text-align:center;
    }
    &-wrapper{
      display: inline-block;
      padding:100px;
      width:100%;
      max-width:900px;
      background:rgba(0,0,0,.6);
      margin:0 auto;
      h4{
        color:#F4EEB4;
        margin-bottom: 30px;
      }
      p{
        color:#ffffff;
        margin-bottom: 30px;
      }
    }
  }

  &-arts{
    float:left;
    width:100%;
    padding:200px 0;
    display: flex;
    justify-content:center;
    align-items:center;
    .container{
      display: flex;
      justify-content:space-between;
      align-items:center;
      text-align:center;
    }
    &-wrapper{
      display: inline-block;
      width:100%;
      position: relative;
      h4{
        color:#F4EEB4;
        margin-bottom: 30px;
      }
      p{
        color:#ffffff;
        margin-bottom: 30px;
      }
      ul{
        display:flex;
        justify-content:space-between;
        align-items:flex-start;
        flex-wrap:wrap;
        position: relative;
        li{
          width:33.33%;
          padding:25px;
          position: relative;
          z-index: 1;
        }
      }
    }
  }

  &-contact{
    float:left;
    width:100%;
    padding:100px 0 200px;
    display: flex;
    justify-content:center;
    align-items:center;
    .container{
      display: flex;
      justify-content:space-between;
      align-items:center;
      text-align:center;
    }
    .page-title{
      padding:0;
      .container{
        align-items:flex-start;
        height:auto;
      }
      &-left{
        text-align:left;
        width:30%;
      }
      &-right{
        width:70%;
        h4{
        margin-bottom:30px;
        }
        h6{
          margin-bottom:30px;
        }
        p{
          margin-bottom:80px;
        }
        .success-msg{
          margin-bottom:0;
          img{
            width:120px;
            display:inline-block;
            vertical-align:middle;
            margin-right:30px;
          }
          span{
            font-size:42px;
            display: inline-block;
            vertical-align: middle;
          }
        }
        ul{
          margin-top:30px;
          li{
            position:relative;
            margin-bottom:50px;
            display:inline-block;
            width:calc(50% - 25px);
            margin-right:25px;
            &:nth-child(2n + 2){
              margin-right:0;
              margin-left:25px;
            }
            &.full{
              width:100%;
              margin-right:0;
              margin-left:0;
                input[type="text"],
                textarea{
                  width:100%;
                  max-width:100%;
                }
            }
          }
        }
        label{
          font-size:32px;
          color:rgba(66, 84, 84, .5);
          display:block;
          position:absolute;
          left: 0;
          top: 0;
          transition: font-size 200ms ease-out;
          transition: transform 200ms ease-out, font-size 200ms ease-out;
          transition: transform 200ms ease-out, font-size 200ms ease-out;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          width: 100%;
        }
        ul{
          li{
            &.active{
              label{
                transform: translateY(-50%);
                font-size: 18px;
                top:-20px;
              }
            }
          }
        }
        input[type="text"],
        textarea{
          font-family: 'Origin_Gordita';
          font-size:32px;
          color:#425454;
          background:none;
          border:0;
          border-bottom:2px solid #425454;
          resize:none;
          width:100%;
          max-width:500px;
          padding:0 0 10px 0;
        }
        textarea{
          height:200px;
          max-width:100%;
        }
        button.send-btn{
          font-family: 'Origin_Gordita';
          font-size:18px;
          font-weight: 500;
          color:#ffebae;
          border:0px;
          width:128px;
          height:128px;
          text-align:center;
          line-height:128px;
          background:#d95b4e;
          border-radius:128px;
        } 
      }
    }
  }
}
@media screen and (min-width: 2560px) {
  .nft{
    &-top{
      .container{
        max-width:90%;
        padding:0 50px;
      }
      &-wrapper{
        h4{
          font-size:185px;
          line-height: 220px;
          span{
            width:250px;
            height:150px;
          }
        }
      }
    }
    &-what{
      &-bottom{
        .container{
          max-width:90%;
        }
        h4{
          font-size:185px;
          line-height: 220px;
        }
      }
    }
  }
}
@media screen and (min-width: 2880px) {
  .nft{
    &-top{
      .container{
        max-width:90%;
        padding:0 50px;
      }
      &-wrapper{
        h4{
          font-size:210px;
          line-height: 240px;
          span{
            width:250px;
            height:160px;
          }
        }
      }
    }
    &-what{
      &-bottom{
        .container{
          max-width:90%;
        }
        h4{
          font-size:210px;
          line-height: 240px;
          margin-bottom:125px;
        }
      }
    }
  }
}
@media screen and (min-width: 3200px) {
  .nft{
    &-top{
      .container{
        max-width:90%;
        padding:0 50px;
      }
      &-wrapper{
        h4{
          font-size:235px;
          line-height: 280px;
          span{
            width:300px;
            height:190px;
          }
        }
      }
    }
    &-what{
      &-bottom{
        .container{
          max-width:90%;
        }
        h4{
          font-size:235px;
          line-height: 280px;
          margin-bottom:150px;
        }
      }
    }
  }
}
@media screen and (max-width: 1280px) {
  .nft{
    &-top{
      &-wrapper{
        padding-top:150px;
        h4{
          font-size:100px;
          line-height: 140px;
          span{
            width:150px;
            height:100px;
          }
        }
      }
    }
    &-about{
      padding:100px 0;
      &-wrapper{
        h5{
          font-size:52px;
          line-heigh:52px;
          margin-bottom:50px;
        }
      }
    }
    &-what{
      padding:50px 0 100px;
      &-wrapper{
        margin-bottom: 50px;
        &-left{
          width:50%;
          padding:100px 50px 100px 0;
        }
      }
      &-bottom{
        h4{
          font-size: 100px;
          line-height: 140px;
        }
      }
    }
    &-benefit{
      padding:100px 0;
      .container{
        h4{
          font-size:52px;
          line-heigh:52px;
          margin-bottom: 50px;
        }
      }
      &-wrapper{
        margin-bottom:50px;
        &:last-child{
          margin-bottom: 0;
        }
      }
    }
    &-brought-life{
      padding:100px 0;
      &-wrapper{
        padding:100px;
      }
    }
    &-arts{
      padding:100px 0;
    }
    &-contact{
      padding:50px 0 0;
    }
  }
}
@media screen and (max-width: 1080px) {
  .nft{
    &-top{
      &-wrapper{
        h4{
          font-size:80px;
          line-height: 120px;
          span{
            width:120px;
            height:80px;
          }
        }
      }
    }
    &-what{
      &-wrapper{
        &-left{
          padding:50px 50px 50px 0;
        }
      }
      &-bottom{
        h4{
          font-size: 80px;
          line-height: 110px;
          margin-bottom: 50px;
        }
      }
    }
    &-benefit{
      &-wrapper{
        height:300px;
      }
    }
    &-brought-life{
      &-wrapper{
        padding:50px;
      }
    }
    &-arts{
      padding:50px 0;
      &-wrapper{
        ul{
          li{
            width: 50%;
            padding:15px;
          }
        }
      }
    }
    &-contact{
      .page-title{
        &-right{
          .success-msg{
            img{
              width:80px;
              display:inline-block;
              vertical-align:middle;
              margin-right:30px;
            }
            span{
              font-size:28px;
              display: inline-block;
              vertical-align: middle;
            }
          }
        }
      }
    }
  }
}
@media screen and (max-width: 767px) {
  .nft{
    &-top{
      height:auto;
      h4{
        font-size: 70px;
        line-height: 110px;
        span{
          width:120px;
          height:70px;
        }
      }
    }
    &-what{
      &-wrapper{
        flex-wrap:wrap;
        flex-direction: column-reverse;
        &-left{
          width:100%;
          padding:50px 0 0;
          h4{
            br{
              display:none;
            }
          }
        }
        &-right{
          width:100%;
          img{
            position:relative;
            top:inherit;
            left:inherit;
            transform:translate(0,0);
            width:100%;
            max-width:100%;
          }
        }
      }
    }
    &-benefit{
      &-wrapper{
        flex-wrap:wrap;
        height:inherit;
        &-left{
          text-align:left;
          padding:0;
          width:100%;
          img{
            margin-bottom:30px;
          }
        }
        &-right{
          text-align:left;
          padding:0;
          width:100%;
          img{
            margin-bottom:30px;
          }
        }
      }
    }
    &-brought-life{
      &-wrapper{
        h4{
          br{
            display:none;
          }
        }
      }
    }
    &-arts{
      &-wrapper{
        ul{
          li{
            width: 100%;
            padding:0;
            margin-bottom:30px;
          }
        }
      }
    }
    &-contact{
      .page-title{
        &-left{
          width:100%;
        }
        &-right{
          width:100%;
          p{
            br{
              display:none;
            }
          }
          label{
            font-size: 24px;
          }
          input[type="text"],
          textarea{
            font-size: 24px;
          }
          button.send-btn{
            width: 90px;
            height: 90px;
            line-height: 90px;
            border-radius: 90px;
          } 
        }
      }
    }
  }
}
@media screen and (max-width: 568px) {
  .nft{
    &-top{
      h4{
        font-size: 58px;
        line-height: 80px;
        letter-spacing:-1px;
        span{
          width:100px;
          height:58px;
        }
      }
    }
    &-about{
      &-wrapper{
          h5{
            font-size:40px;
          }
      }
    }
    &-what{
      &-bottom{
        h4{
          font-size: 70px;
          line-height: 90px;
        }
      }
    }
    &-contact{
      .page-title{
        &-right{
          label{
            font-size: 20px;
          }
          input[type="text"],
          textarea{
            font-size: 20px;
          }
          ul{
            li{
              width:100%;
              margin-left:0;
              margin-right:0;
              margin-bottom:30px;
              &:nth-child(2n + 2){
                margin-left:0;
                margin-right:0;
                margin-bottom:30px;
              }
            }
          }
        }
      }
    }
  }
}
</style>
